import { render } from "./Main.vue?vue&type=template&id=0f090b2c&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=0f090b2c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Kuppen_front/Kuppen_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f090b2c"]])

export default __exports__